module.exports = __webpack_public_path__ + "05_long_black.5885653a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_long_black.png
// module id = k7+M
// module chunks = 0